import React from 'react';
import ContractForm from '../../form/subscription/ContractForm';
// import useApplicationSession from "../../session/UserSession";

const Contract = () => {
    // const token = useApplicationSession();

    return (
        <div test_id="subscription-contract" className="subscriptionContentContainer">
            <ContractForm />
        </div>
    );
};

export default Contract;
